import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { map, Observable, of } from "rxjs";
import { SeasonService } from "../../shared/services/season.service";
import { SeasonResponse } from "../../shared/models/season.model";

@Injectable({
    providedIn: 'root',
})
export class GetSeasonsResolver implements Resolve<SeasonResponse[]> {

    constructor(
        private seasonService: SeasonService,
    ) { }

    resolve(): Observable<SeasonResponse[]> {
        
        return this.seasonService.getAll()
            .pipe(
                map(seasons =>
                    seasons.filter(x => !x.isDeleted)
                        .map(season => ({
                            ...season,
                            seasonStartDate: new Date(season.seasonStartDate),
                            seasonEndDate: new Date(season.seasonEndDate),
                        }))
                )
            );
    }
}
